<!-- <mat-card-header class="titreFrm">
    <mat-card-title>Suppression !</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div style="padding: 10px 10px 0 10px; ">
      <h4>{{message}}</h4>

      
    </div>

  </mat-card-content>
  <div align="end">
    <button style="margin-right: 10px;" (click)="close('annuler')" mat-raised-button [ngClass]="btnAnnuler.class"><mat-icon>{{btnAnnuler.icon}}</mat-icon>{{btnAnnuler.text}}</button>
    <button (click)="close('supprimer')" mat-raised-button [ngClass]="btnOk.class"><mat-icon>{{btnOk.icon}}</mat-icon>{{btnOk.text}}</button>
  </div> -->

  <div
  class="min-w-screen h-screen fixed flex justify-center items-center inset-0 z-50 transition"
>
  <div class="absolute bg-black opacity-80 inset-0 z-0"></div>
  <div
    class="w-full max-w-lg p-5 relative mx-auto my-auto rounded-xl shadow-lg bg-white"
  >
    <!--content-->
    <div class="">
      <!--body-->
      <div class="text-center p-5 flex-auto justify-center">
        <svg
          class="w-50 h-50 flex items-center text-yellow-600 mx-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>

        <h2 class="text-xl font-bold py-4">Es-tu sûr?</h2>
        <p class="text-lg text-gray-500 px-8">
          {{ message }}
        </p>
      </div>
      <!--footer-->
      <div class="p-3 mt-2 text-center space-x-4 md:block">
        <button
          (click)="close('annuler')"
          class="mb-2 md:mb-0 bg-white px-5 py-8 text-xl shadow-sm font-medium tracking-wider border text-gray-600 rounded-lg hover:shadow-lg hover:bg-gray-100"
        >
          Annuler
        </button>
        <button
          (click)="close('Confirmer')"
          class="mb-2 md:mb-0 bg-yellow-700 border border-yellow-700 px-5 py-8 text-xl shadow-sm font-medium tracking-wider text-white rounded-lg hover:shadow-lg hover:bg-yellow-800"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>
</div>
